module.exports = __webpack_public_path__ + "img/bs_banner_es.3ff063d0.jpg";